<template>
  <div class="event">
    <p class="event_text">
      <span>まずは「イベント」に参加し、</span
      ><span>希望にマッチした研修病院を探そう！</span>
    </p>

    <router-link to="/events/list">
      <picture>
        <source
          media="(max-width: 899px)"
          srcset="@/assets/images/common/fesBanner-sm.png"
        />
        <img
          src="@/assets/images/common/fesBanner-lg.png"
          alt="医学生のための合同臨床研修プログラム説明会 マイナビRESIDENT FESTIVAL"
        />
      </picture>
    </router-link>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EventBanner'
}
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.event {
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  font-weight: bold;

  @include mixins.media() {
    font-size: 1.8rem;
  }

  &_text {
    span {
      display: inline-block;
    }
  }

  img {
    width: 100%;
    max-width: 400px;
    margin-top: 13px;
    margin-left: auto;
    margin-right: auto;

    @include mixins.media() {
      max-width: 900px;
      margin-top: 18px;
    }
  }
}
</style>
